import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';

import MotiveTitle from '../../../mis-compras/components/report-issue-view/mobile/forms-views/MotiveTitle';

const MobileIssueBody = (props) => {
  const { children, icon, title, subtitle } = props;
  return (
    <Box>
      <MotiveTitle icon={icon} title={title} subtitle={subtitle} />
      {children}
    </Box>
  );
};

MobileIssueBody.propTypes = {
  children: PropTypes.node,
  icon: PropTypes.node,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default MobileIssueBody;
